<template lang="pug">
.non-profit
  img.non-profit__bg(src="/svg/pricing/NonProfitBackground.svg")
  .non-profit__container.inner-1080
    .non-profit__box
      HandIconSvg.non-profit__box-icon
      h4.non-profit__box-title {{ $t('pages.ssr_pricing_plans.non_profit.title') }}
      p.non-profit__box-text {{ $t('pages.ssr_pricing_plans.non_profit.text') }}
      Link.non-profit__box-link.link-button-arrow-animation(
        href="#"
        is-unstyled
        @click.prevent="openFreshdeskWidget"
      )
        template {{ $t('pages.ssr_pricing_plans.non_profit.link') }}
        .link-button-arrow-animation__i
          SmallArrowIcon
</template>

<script>
import HandIconSvg from './svg/HandIcon'
import SmallArrowIcon from '@/components/icons/default/ArrowSmall'
import Link from '@/components/common/Link/Link'

export default {
  components: {
    HandIconSvg,
    SmallArrowIcon,
    Link
  },

  methods: {
    openFreshdeskWidget () {
      // eslint-disable-next-line
      FreshworksWidget('open', 'ticketForm')
    }
  }
}
</script>

<style lang="scss" scoped>
.non-profit {
  width: 100%;
  overflow: hidden;
  padding-top: 40px;
  position: relative;
  background: #25163A;
  padding-bottom: 40px;

  @include display-less(tablet) {
    padding: $gap;
    margin-bottom: 80px;
  }

  &__bg {
    left: 50%;
    z-index: 1;
    bottom: -24px;
    width: 1602px;
    min-width: 1602px;
    position: absolute;
    margin-left: -450px;

    @include display-less(tablet) {
      margin-left: -950px;
    }
  }

  &__container {
    min-width: 280px;
  }

  &__box {
    z-index: 2;
    width: 100%;
    display: flex;
    text-align: center;
    border-radius: 8px;
    position: relative;
    padding: $gap * 1.5;
    padding-left: 295px;
    padding-right: 295px;
    background: #2E1F42;
    align-items: center;
    flex-direction: column;

    @include display-less(desktop) {
      padding-left: 100px;
      padding-right: 100px;
    }

    @include display-less(tablet) {
      padding-left: $gap * 1.5;
      padding-right: $gap * 1.5;
    }

    &-icon {
      width: 40px;
      height: 40px;
      margin-bottom: $gap;
    }

    &-title {
      color: #FFFFFF;
      font-size: 22px;
      font-weight: bold;
    }

    &-text {
      color: #fff;
      font-size: 16px;
      margin-bottom: $gap;
    }

    &-link {
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      text-decoration: none;
    }
  }
}
</style>
